import { ValueOption } from "../../../design-system/dropdown/selection-box/types"
import { searchableItemNames } from "../names"
import { CatalogItem } from "./catalog-table/types"

const getOption = (code: string, label?: string): ValueOption => ({
  value: code,
  label: label ?? code,
})

interface UniqueOption {
  countryOptions: ValueOption[]
  currencyOptions: ValueOption[]
}

export const getUniqueOptions = (
  catalogItems: CatalogItem[],
  getSublist: (
    item: CatalogItem,
  ) => Array<{ code: string; label?: string }> = item => item.countries,
): UniqueOption => {
  const countryOptionSet = new Set<string>()
  const uniqueOptions: ValueOption[] = []

  const currencyOptionsSet = new Set<string>()

  catalogItems?.forEach(item => {
    const sublist = getSublist(item)

    sublist?.forEach(({ code, label }) => {
      if (!countryOptionSet.has(code)) {
        countryOptionSet.add(code)
        uniqueOptions.push(getOption(code, label))
      }
    })

    item.currencyCodes.forEach(code => currencyOptionsSet.add(code))
  })

  return {
    countryOptions: uniqueOptions.sort((a, b) =>
      a.label.localeCompare(b.label),
    ),
    currencyOptions: [...currencyOptionsSet].map(code => getOption(code)),
  }
}

export const itemNameMatchesSearch = (
  catalogItems: CatalogItem,
  search: string,
  caseSensitive = false,
): boolean => {
  const searchableNames = searchableItemNames(catalogItems.name)
  const transformedCase = (term: string) =>
    caseSensitive ? term : term.toLowerCase()
  const matching = searchableNames.filter(name => {
    return transformedCase(name).includes(transformedCase(search))
  })

  return matching.length > 0
}

export const sortByCountriesCount = (a: CatalogItem, b: CatalogItem) => {
  return b.countries.length - a.countries.length
}
